import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[curbnturfDisplayValidationErrorsSubmitButtonContainer]',
  standalone: true,
})
export class DisplayValidationErrorsSubmitButtonContainerDirective {
  constructor(public vcr: ViewContainerRef) {}
}
